import { Action } from '@ngrx/store';
import { TFactoryShiftInfoActionType, TShiftCategoryTab } from './factory-shift.models';
import {
  TREQUEST_ADD_EDIT_FACTORY_HOLIDAYS,
  TREQUEST_ADD_EDIT_OPERATOR_COUNT,
  TREQUEST_ADD_EDIT_WORKFORCE_COUNT,
  TREQUEST_ADD_EDIT_WORKING_HOURS,
  TREQUEST_DELETE_FACTORY_HOLIDAYS,
  TREQUEST_FACTORY_SHIFT,
  TREQUEST_RESET_COUNT,
  TREQUEST_UPDATE_DEFAULT_WORKFORCE_COUNT,
  TREQUEST_UPDATE_DEFAULT_WORKING_HOURS_REQUEST,
  TREQUEST_WORKFORCE_RESET_TO_DEFAULT,
  TRESPONSE_FACTORY_HOLIDAYS,
  TRESPONSE_FACTORY_SHIFT,
} from '@monorepo/types';

export class ClearFactoryShiftInfo implements Action {
  readonly type = TFactoryShiftInfoActionType.ClearFactoryShiftInfo;
  constructor() {}
}

export class SetShiftCategoryTab implements Action {
  readonly type = TFactoryShiftInfoActionType.SetShiftCategoryTab;
  constructor(public currentTab: TShiftCategoryTab) {}
}
export class GetFactoryShiftInfo implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryShiftInfo;
  constructor(public factoryId: string, public payload: TREQUEST_FACTORY_SHIFT) {}
}

export class GetFactoryShiftInfoSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryShiftInfoSuccess;
  constructor(public factoryShiftRes: TRESPONSE_FACTORY_SHIFT) {}
}

export class GetFactoryShiftInfoFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryShiftInfoFailure;
}

export class AddEditOperatorCount implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditOperatorCount;
  constructor(public factoryId: string, public payload: TREQUEST_ADD_EDIT_OPERATOR_COUNT, public shiftId: string) {}
}

export class AddEditOperatorCountSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditOperatorCountSuccess;
}

export class AddEditOperatorCountFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditOperatorCountFailure;
}

export class AddEditWorkingHours implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkingHours;
  constructor(public factoryId: string, public payload: TREQUEST_ADD_EDIT_WORKING_HOURS) {}
}

export class AddEditWorkingHoursSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkingHoursSuccess;
}

export class AddEditWorkingHoursFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkingHoursFailure;
}
export class ResetOperatorCount implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetOperatorCount;
  constructor(public factoryId: string, public payload: TREQUEST_RESET_COUNT) {}
}

export class ResetOperatorCountSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetOperatorCountSuccess;
}

export class ResetOperatorCountFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetOperatorCountFailure;
}

export class ResetWorkingHours implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetWorkingHours;
  constructor(public factoryId: string, public payload: TREQUEST_RESET_COUNT) {}
}

export class ResetWorkingHoursSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetWorkingHoursSuccess;
}

export class ResetWorkingHoursFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.ResetWorkingHoursFailure;
}

export class GetFactoryHolidayInfo implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryHolidaysInfo;
  constructor(public factoryId: string) {}
}

export class GetFactoryHolidayInfoSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryHolidaysInfoSuccess;
  constructor(public factoryHolidayRes: TRESPONSE_FACTORY_HOLIDAYS) {}
}

export class GetFactoryHolidayInfoFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.GetFactoryHolidaysInfoFailure;
}

export class AddEditFactoryHoliday implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditFactoryHoliday;
  constructor(public factoryId: string, public payload: TREQUEST_ADD_EDIT_FACTORY_HOLIDAYS) {}
}

export class DeleteFactoryHoliday implements Action {
  readonly type = TFactoryShiftInfoActionType.DeleteFactoryHoliday;
  constructor(public factoryId: string, public payload: TREQUEST_DELETE_FACTORY_HOLIDAYS) {}
}

export class DeleteFactoryHolidaySuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.DeleteFactoryHolidaySuccess;
}

export class DeleteFactoryHolidayFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.DeleteFactoryHolidayFailure;
}

export class UpdateDefaultWorkforceCountRequest implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkforceCountRequest;
  constructor(public payload: TREQUEST_UPDATE_DEFAULT_WORKFORCE_COUNT) {}
}

export class UpdateDefaultWorkforceCountRequestSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkforceCountRequestSuccess;
}

export class UpdateDefaultWorkforceCountRequestFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkforceCountRequestFailure;
}

export class UpdateDefaultWorkingHoursRequest implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkingHoursRequest;
  constructor(public payload: TREQUEST_UPDATE_DEFAULT_WORKING_HOURS_REQUEST, public factoryId: string) {}
}

export class UpdateDefaultWorkingHoursRequestSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkingHoursRequestSuccess;
}

export class UpdateDefaultWorkingHoursRequestFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.UpdateDefaultWorkingHoursRequestFailure;
}

export class AddEditWorkForceCount implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkForceCount;
  constructor(public payload: TREQUEST_ADD_EDIT_WORKFORCE_COUNT, public factoryId: string) {}
}

export class AddEditWorkForceCountSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkForceCountSuccess;
}

export class AddEditWorkForceCountFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.AddEditWorkForceCountFailure;
}

export class WorkForceResetToDefault implements Action {
  readonly type = TFactoryShiftInfoActionType.WorkForceResetToDefault;
  constructor(public payload: TREQUEST_WORKFORCE_RESET_TO_DEFAULT, public factoryId: string) {}
}

export class WorkForceResetToDefaultSuccess implements Action {
  readonly type = TFactoryShiftInfoActionType.WorkForceResetToDefaultSuccess;
}

export class WorkForceResetToDefaultFailure implements Action {
  readonly type = TFactoryShiftInfoActionType.WorkForceResetToDefaultFailure;
}

export type TFactoryShiftActions =
  | ClearFactoryShiftInfo
  | SetShiftCategoryTab
  | GetFactoryShiftInfo
  | GetFactoryShiftInfoSuccess
  | GetFactoryShiftInfoFailure
  | AddEditOperatorCount
  | AddEditOperatorCountSuccess
  | AddEditOperatorCountFailure
  | AddEditWorkingHours
  | AddEditWorkingHoursSuccess
  | AddEditWorkingHoursFailure
  | ResetOperatorCount
  | ResetOperatorCountSuccess
  | ResetOperatorCountFailure
  | ResetWorkingHours
  | ResetWorkingHoursSuccess
  | ResetWorkingHoursFailure
  | GetFactoryHolidayInfo
  | AddEditFactoryHoliday
  | GetFactoryHolidayInfoSuccess
  | GetFactoryHolidayInfoFailure
  | DeleteFactoryHoliday
  | DeleteFactoryHolidaySuccess
  | DeleteFactoryHolidayFailure
  | UpdateDefaultWorkforceCountRequest
  | UpdateDefaultWorkforceCountRequestSuccess
  | UpdateDefaultWorkforceCountRequestFailure
  | UpdateDefaultWorkingHoursRequest
  | UpdateDefaultWorkingHoursRequestSuccess
  | UpdateDefaultWorkingHoursRequestFailure
  | AddEditWorkForceCount
  | AddEditWorkForceCountSuccess
  | AddEditWorkForceCountFailure
  | WorkForceResetToDefault
  | WorkForceResetToDefaultSuccess
  | WorkForceResetToDefaultFailure;
